import { services } from '@ambita/ambita-components-core';
import * as cadastreReportActions from '../../actions/cadastreReport';
import cadastreReportStore from '../../stores/cadastreReport';
import * as cadastreReportConstants from '../../constants/cadastreReport';
import i18nMixin from '../i18nMixin';

const { domUtils: { classUtils }, util } = services;
const { events: cadastreReportEvents } = cadastreReportConstants;
const CLICKABLE_CADASTRE_CLASS = 'ambita-clickable-cadastre';

export const init = (tag): void => {
  tag.mixin(i18nMixin);

  const handleCadastreClick = (event): void => {
    if (classUtils.hasClass(event.target, CLICKABLE_CADASTRE_CLASS)) {
      const cadastreNumber = util.stringReplaceAll(event.target.innerText.trim(), '/', '-').replace(/^0+/, '');
      tag.opts.cadastreClickHandler(cadastreNumber);
    }
  };

  const setLoadingStartedStatus = (): void => {
    tag.loading = true;
    tag.update();
  };

  const setLoadingFinishedStatus = (): void => {
    tag.loading = false;
    tag.update();

    if (!tag.opts.multipleReport && util.isFunction(tag.opts.onTaskDone)) {
      tag.opts.onTaskDone();
    }
  };

  tag.on('mount', () => {
    tag.hasCadastreClickHandler = util.isFunction(tag.opts.cadastreClickHandler);

    if (tag.hasCadastreClickHandler) {
      tag.root.addEventListener('click', handleCadastreClick, false);
    }

    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADING, setLoadingStartedStatus);
    cadastreReportStore.on(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, setLoadingFinishedStatus);

    if (!tag.opts.multipleReport) {
      cadastreReportActions.requestCadastreLookup(tag.opts.propertyKey);
    }
  });

  tag.on('unmount', () => {
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADING, setLoadingStartedStatus);
    cadastreReportStore.off(cadastreReportEvents.CADASTRE_LOOKUP_LOADED, setLoadingFinishedStatus);
  });
};
